module.exports = __webpack_public_path__ + "static/media/22ESCWA17.0f9a47d5.jpg";